import React, { useState } from "react";
import { Grid, Paper, Typography, Select, MenuItem, Box } from "@mui/material";

const TopBarPanel = ({
  paneldata = [],
  select = null,
  selectOnClick = () => {},
  rightSideComponent = <></>,
  defaultValue = null,
}) => {
  const [selectValue, setSelectValue] = useState(
    defaultValue || select?.data[0]?.label || "",
  );
  const handleChange = (event) => {
    setSelectValue(event.target.value);
    selectOnClick(event.target.value);
  };
  return (
    <Paper
      elevation={2}
      key="select"
      sx={{
        border: "solid 1px #8283be",
        padding: 2,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {select && (
          <Grid item xs={12} sm={2}>
            {select.label && (
              <Typography variant="subtitle2" color="textSecondary">
                {select.label}
              </Typography>
            )}
            <Select
              value={selectValue}
              variant="standard"
              fullWidth
              disableUnderline
              sx={{ fontWeight: "700", color: "black" }}
              onChange={handleChange}
            >
              {select?.data?.map((val, i) => (
                <MenuItem key={i} value={val.label}>
                  {val.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}

        {/* Prospects Not Logged In */}
        {paneldata.map((val) => (
          <Grid item xs={6} sm={val?.size || 2}>
            <Typography variant="subtitle2" color="textSecondary">
              {val?.label}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "500" }}>
              {val?.value}
            </Typography>
          </Grid>
        ))}
      </Grid>

      {/* Icon */}
      <Box sx={{ ml: 2, display: "flex", alignItems: "center" }}>
        {rightSideComponent}
      </Box>
    </Paper>
  );
};

export default TopBarPanel;
